export default [{
  path: '/calendar',
  name: 'calendar',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/calendar/index')
}]
